import { _ as __rest } from '../../tslib.es6-C8rd5pYo.mjs';
import { Icon } from '@zapier/design-system';
import { clsx } from 'clsx';
import React, { useContext } from 'react';
import { TagGroupContext, Tag, Button } from 'react-aria-components';

const root = "_root_pr4ue_1";
const titleLabelWrapper = "_title-label-wrapper_pr4ue_67";
const title = "_title_pr4ue_67";
const label = "_label_pr4ue_98";
const removalButton = "_removalButton_pr4ue_116";
const styles = {
	root: root,
	titleLabelWrapper: titleLabelWrapper,
	title: title,
	label: label,
	removalButton: removalButton
};

const FilterChip = (_a) => {
  var _b, _c, _d;
  var { children, className, id, isDisabled, label, showsCheckmarkWhenSelected = false, size: sizeFromProps = "small", style, title, variant: variantFromProps = "primary" } = _a, props = __rest(_a, ["children", "className", "id", "isDisabled", "label", "showsCheckmarkWhenSelected", "size", "style", "title", "variant"]);
  const tagGroupContext = useContext(TagGroupContext);
  const size = (_b = tagGroupContext === null || tagGroupContext === void 0 ? void 0 : tagGroupContext.size) !== null && _b !== void 0 ? _b : sizeFromProps;
  const variant = (_c = tagGroupContext === null || tagGroupContext === void 0 ? void 0 : tagGroupContext.variant) !== null && _c !== void 0 ? _c : variantFromProps;
  return React.createElement(Tag, Object.assign({}, props, { className: clsx(className, styles.root), "data-selectable": (_d = tagGroupContext === null || tagGroupContext === void 0 ? void 0 : tagGroupContext.selectionMode) !== null && _d !== void 0 ? _d : void 0, "data-size": size, "data-variant": variant, "data-zds": true, id, isDisabled, style, textValue: label ? `${title} ${label}` : title }), (tagRenderProps) => React.createElement(
    React.Fragment,
    null,
    tagRenderProps.isSelected && showsCheckmarkWhenSelected && React.createElement(Icon, { name: "formCheck" }),
    typeof children === "function" ? children(tagRenderProps) : children,
    title && React.createElement(
      "div",
      { className: styles.titleLabelWrapper, "data-zds": true },
      React.createElement("span", { className: styles.title, "data-zds": true, "data-testid": "filter-chip-title" }, title),
      !!label && React.createElement("span", { className: styles.label, "data-zds": true, "data-testid": "filter-chip-label" }, label)
    ),
    tagRenderProps.allowsRemoving && React.createElement(
      Button,
      { className: styles.removalButton, "data-zds": true, slot: "remove" },
      React.createElement(Icon, { color: "StrokeStronger", name: "formX" })
    )
  ));
};
const FilterChipIcon = ({ name }) => React.createElement(Icon, { name });

export { FilterChip, FilterChipIcon };
//# sourceMappingURL=FilterChip.es.js.map
